// APP CONSTATNS
export const DEBUG = false
export const MOCK = false
export const APP_NAME = 'CloudManager'
export const API_URL =
  {
    'logs.icure.dev': 'https://atna.icure.dev/rest/v1',
    '127.0.0.1': 'http://127.0.0.1:8082/rest/v1',
    localhost: 'http://localhost:8082/rest/v1',
  }[new URL(window.location.href).host.split(':')[0]] || 'https://atna.icure.dev/rest/v1'
